import React, { useContext } from "react";
import TopBar from "./TopBar";
import { Link } from "react-router-dom";
import { Store } from "../../Utils/Store";

function Header() {
    const { state } = useContext(Store);
    const { ContactInfo } = state;

    const handleMobileMenuToggle = () => {
        // Toggle the menu visibility
        document.body.classList.toggle('mobile-menu-visible');
    };

    const closeMobileMenu = () => {
        // Close the mobile menu
        document.body.classList.remove('mobile-menu-visible');
    };

    return (
        <>
            <header className="main-header main-header-one">
                <div id="sticky-header" className="menu-area">
                    <div className="container">
                        <div className="menu-area__inner">
                            <div className="mobile-nav-toggler" onClick={handleMobileMenuToggle}>
                                <i className="fas fa-bars" />
                            </div>
                            <div className="menu-wrap">
                                <nav className="menu-nav">
                                    <div className="logo-box-one">
                                        <Link to="/" onClick={closeMobileMenu}>
                                            <img width="180px" src="assets/img/resource/logo.png" alt="Logo" />
                                        </Link>
                                    </div>
                                    <div className="navbar-wrap main-menu">
                                        <ul className="navigation">
                                            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                                            <li><Link to="/ai-models" onClick={closeMobileMenu}>AI Models</Link></li>
                                            <li><Link to="/projects" onClick={closeMobileMenu}>Projects</Link></li>
                                            <li><Link to="/services" onClick={closeMobileMenu}>Services</Link></li>
                                            <li><Link to="/about-us" onClick={closeMobileMenu}>About Us</Link></li>
                                            <li><Link to="/contact-us" onClick={closeMobileMenu}>Contact Us</Link></li>
                                        </ul>
                                    </div>
                                    <div className="menu-nav__right">
                                        <div className="contact-info-box-one">
                                            <div className="icon">
                                                <span className="icon-chat" />
                                            </div>
                                            <div className="text">
                                                <p>Need help?</p>
                                                <Link to={`tel:${ContactInfo?.contact_phone || '123456789'}`} onClick={closeMobileMenu}>
                                                    {ContactInfo?.contact_phone || '123456789'}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        {/* Mobile Menu */}
                        <div className="mobile-menu">
                            <nav className="menu-box">
                                <div className="close-btn" onClick={handleMobileMenuToggle}>
                                    <i className="fas fa-times" />
                                </div>
                                <div className="nav-logo">
                                    <Link to="/" onClick={closeMobileMenu}>
                                        <img src="assets/img/resource/logo.png" alt="Logo" />
                                    </Link>
                                </div>
                                <div className="menu-outer">
                                    <ul className="navigation">
                                        <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                                        <li><Link to="/ai-models" onClick={closeMobileMenu}>AI Models</Link></li>
                                        <li><Link to="/projects" onClick={closeMobileMenu}>Projects</Link></li>
                                        <li><Link to="/services" onClick={closeMobileMenu}>Services</Link></li>
                                        <li><Link to="/about-us" onClick={closeMobileMenu}>About Us</Link></li>
                                        <li><Link to="/contact-us" onClick={closeMobileMenu}>Contact Us</Link></li>
                                    </ul>
                                </div>
                                <div className="contact-info">
                                    <div className="icon-box">
                                        <span className="icon-call" />
                                    </div>
                                    <p>
                                        <Link to={`tel:${ContactInfo?.contact_phone || '123456789'}`} onClick={closeMobileMenu}>
                                            {ContactInfo?.contact_phone || '123456789'}
                                        </Link>
                                    </p>
                                </div>
                                <div className="social-links">
                                    <ul className="clearfix list-wrap">
                                        <li><Link to="#"><i className="fab fa-facebook-f" /></Link></li>
                                        <li><Link to="#"><i className="fab fa-twitter" /></Link></li>
                                        <li><Link to="#"><i className="fab fa-instagram" /></Link></li>
                                        <li><Link to="#"><i className="fab fa-linkedin-in" /></Link></li>
                                        <li><Link to="#"><i className="fab fa-youtube" /></Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="menu-backdrop" />
                        {/* End Mobile Menu */}
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
